/**************************************************
 * Nombre:       Home_Pagos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import pagos from "../../../Recursos/Graficos/pagos.png";
import pagos_cell from "../../../Recursos/Graficos/pagos_cell.png";
import {useRef} from "react";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Pagos = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <img src={sCell ? pagos_cell : pagos} width={'100%'} height={'auto'} />

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Pagos